<script setup>
import {ref, inject, watch, onMounted} from "vue";
import CorporateSelector from "@/components/ui/CorporatesSelector.vue";
import PrimaryButton from "@/components/ui/PrimaryButton.vue";
import marketsService from "@/services/markets.service";

const selectedCorporates = inject('selectedCorporates');
const showModal = ref(false);

const corporates = ref([]);
const defaultList = ref([]);

watch(selectedCorporates, (value) => {
    corporates.value = value;
}, {immediate: true});

onMounted(() => {
    getDefaultList();
});

async function getDefaultList() {
    const {data} = await marketsService.getMostFrequentCorporatesList();

    defaultList.value = data;
}

function apply() {
    selectedCorporates.value = corporates.value;
    showModal.value = false;
}

function open() {
    showModal.value = true;
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" title="Select Enterprises">
        <CorporateSelector
            v-model="corporates"
            :default-list="defaultList"
            multiple
        />

        <template #modal-footer>
            <PrimaryButton
                caption="Apply"
                @click="apply"
            />
        </template>
    </b-modal>
</template>

<style scoped>

</style>
